CDN.requireOnce([
    { code: CDN.PackageCode.Control_PlaybackController, },
    { code: CDN.PackageCode.Control_UI_Button, },
], () => {
    //document.addEventListener('DOMContentLoaded', onReady);
    onReady();
});

function onReady() {
    let pbc = new CDN.Controls.PlaybackControl.PlaybackController(document.querySelector('main'), {
        onPlayClicked: () => {
            console.log('play');
        },
        onStepBackwardClicked: () => {
            console.log('backward');
        },
        onPauseClicked: () => {
            console.log('pause');
        },
        onStepForwardClicked: () => {
            console.log('forward');
        },
        speed: {
            show: true,
            initialSpeed: 1,
            presets: [1, 10, 100, 1000],
        }
    });

    let disableBtn = new CDN.Controls.UI.Button(document.querySelector('main'), {
        text: () => {
            if (pbc.enabled) return 'Disable';
            return 'Enable';
        },
        afterSelectionAsync: async () => {
            if (pbc.enabled) pbc.disable();
            else pbc.enable();
        },
    });
}